import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Observer } from 'rxjs';
import { ApiService, AuthService, AuthToken, AuthUser } from '@solcre-org/core';
import { environment } from '../../../environments/environment.local';
import { GlobalApiConfigService } from '@solcre-org/core-ui';

@Injectable({
  providedIn: 'root',
})
export class InitializerService {
  private router: Router = inject(Router);
  private apiService: ApiService = inject(ApiService);
  private authService: AuthService = inject(AuthService);
  private globalApiConfigService: GlobalApiConfigService = inject(
    GlobalApiConfigService
  );
  private loginState: string = environment.STATES.LOGIN;
  private publicRoutes: string[] = [
    environment.STATES.LOGIN,
    environment.STATES.FORGOT_PASSWORD,
    environment.STATES.RESET_PASSWORD,
  ];

  public setLoginState(state: string): void {
    this.loginState = state;
  }
  public getLoginState(): string {
    return this.loginState;
  }

  public init(): Observable<any> {
    const apiUrl: string = environment.API_URL;
    const oauthUri: string = environment.API.OAUTH_URI;
    const refreshTokenUri: string = environment.API.OAUTH_REFRESH_URI;

    this.authService.setConfig({
      apiUrl,
      refreshTokenUri,
      oauthUri,
      oauthUsernameField: 'email',
      checkTokenInsteadUserId: true,
    });

    this.globalApiConfigService.configure({
      apiUrl,
      filesPresignedUrl: '',
      filesDownloadUrl: '',
      filesConfirmUploadUrl: '',
      updateWithPatch: true,
    });

    this.apiService.setConfig({
      apiUrl,
    });

    return new Observable((observer: Observer<void>) => {
      const initialUrl = window.location.pathname;
      // if (
      //   initialUrl.includes('/recover-password') ||
      //   initialUrl.includes('/forgot-password')
      // ) {
      //   this.clearAllAuthStorage();
      //   this.authService.logout();
      //   this.permissionService.setUser(null);
      //   this.apiService.setAccessToken('');
      //   observer.next();
      //   observer.complete();
      //   return;
      // }
      this.authService.loadSession().subscribe({
        next: (res) => {
          //@@TODO: Change this
          const token: AuthToken | null = this.authService.getAccessToken();
          if (token) {
            this.loadAuthUser(initialUrl);
            observer.next();
            observer.complete();
          } else {
            this.handlePublicRoute(initialUrl, observer);
          }
        },
        error: (error) => {
          this.handlePublicRoute(initialUrl, observer);
        },
        complete: () => {
          this.handlePublicRoute(initialUrl, observer);
        },
      });
    });
  }
  private handlePublicRoute(
    currentUrl: string,
    observer: Observer<void>
  ): void {
    // Uncomment this to use public routes
    if (
      !this.authService.getLoggedUser() &&
      !this.publicRoutes.includes(currentUrl)
    ) {
      this.router
        .navigate([this.getLoginState()])
        .then((success) => {
          observer.next();
          observer.complete();
        })
        .catch((err) => {
          observer.next();
          observer.complete();
        });
    } else {
      observer.next();
      observer.complete();
    }
    observer.next();
    observer.complete();
  }

  private loadAuthUser(currentUrl: string): void {
    const data: any = this.authService.getLoggedStartData();
    if (!!data) {
      const authUser: AuthUser = {
        id: data?.id,
        name: data?.first_name,
        lastName: data?.last_name,
      };
      this.authService.setLoggedUser(authUser);
    }
    // const userModel = new UsersModel();
    // const user = userModel.fromJSON(data);
    // this.permissionService.setUser(user);
    this.apiService.setAccessToken(this.authService.getAccessToken()?.token!);
    this.setLoginState(environment.STATES.AUTHENTICATED);
    if (currentUrl === '/app' || currentUrl === '/auth') {
      setTimeout(() => {
        this.router.navigate([environment.STATES.AUTHENTICATED]);
      }, 0);
    }
  }
  private clearAllAuthStorage(): void {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(';').forEach((c) => {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
  }
}
